import { useState } from "react";
import { ChevronLeft, Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { MobileNavDrawer } from "./mobile-nav-drawer";
import { Link, useLocation, useNavigate } from "react-router";

const BackButtonNav = () => {
	const navigate = useNavigate();

	return (
		<Button variant="secondary" size="icon" onClick={() => navigate(-1)}>
			<ChevronLeft className="h-6 w-6" />
			<span className="sr-only">Open menu</span>
		</Button>
	);
};

export function MobileNavbarTop() {
	const location = useLocation();
	const [isOpen, setIsOpen] = useState(false);

	const isHomeOrFeedPage =
		location.pathname === "/" || location.pathname === "/home";

	return (
		<nav className="top-0 left-0 right-0 bg-[hsl(var(--sidebar-background-start))]">
			<div className="mx-auto px-4 sm:px-8 h-16 flex items-center justify-between">
				<div className="flex items-center gap-2 text-lg font-medium">
					<Link to="/" className="">
						{isHomeOrFeedPage ? (
							<img
								className="h10 w-10 rounded-lg"
								src="/logos/icon.svg"
								alt="Logo"
							/>
						) : (
							<BackButtonNav />
						)}
					</Link>
					Coffitivity
				</div>
				<Button variant="secondary" size="icon" onClick={() => setIsOpen(true)}>
					<Menu className="h-6 w-6" />
					<span className="sr-only">Open menu</span>
				</Button>
			</div>
			<MobileNavDrawer isOpen={isOpen} setIsOpen={setIsOpen} />
		</nav>
	);
}
